import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
import { LazyLoadFallback } from '../page-common/LazyLoadFallback';
var LazyViewPage = lazyForPaint(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-view-page" */
  './ViewPage');
});
export var ViewPage = function ViewPage(props) {
  return /*#__PURE__*/React.createElement(LazySuspense, {
    fallback: /*#__PURE__*/React.createElement(LazyLoadFallback, null)
  }, /*#__PURE__*/React.createElement(LazyViewPage, props));
};